(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-blur"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBlurToggle(root) {
      const toggle = root.querySelector('[data-hero-blur-toggle]');
      const overlay = root.querySelector('.hero-blur__overlay');
      if (!toggle || !overlay) return;

      toggle.addEventListener('click', () => {
        const isActive = overlay.classList.contains('hero-blur__overlay--active');
        overlay.classList.toggle('hero-blur__overlay--active', !isActive);
        root.dataset.blurEnabled = String(!isActive);
        toggle.setAttribute('aria-pressed', String(!isActive));
      });
    }

    document.querySelectorAll('.hero-blur').forEach(initBlurToggle);

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('.hero-blur').forEach(initBlurToggle);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
